export const fakeProducts = [
  {
    id: '1',
    uuid: '1',
    titulo: 'iPhone 15 Pro Max 256GB',
    precio: 1200,
    descripcion: 'iPhone 15 Pro Max en titanio natural, 256GB de almacenamiento. Incluye cargador original, caja y protector de pantalla aplicado. Batería al 98% de salud. Sin rayones ni golpes.',
    fotos: ['https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=400', 'https://images.unsplash.com/photo-1592750475338-74b7b21085ab?w=400'],
    ownerId: 'user1',
    ownerName: 'Carlos Tech Pro',
    tags: ['iphone', 'apple', 'smartphone', 'premium'],
    estado: 'Excelente',
    ubicacion: 'CABA, Argentina',
    categoria: 'smartphones',
    createdAt: new Date('2024-01-15')
  },
  {
    id: '2',
    uuid: '2',
    titulo: 'MacBook Pro M3 14" 512GB',
    precio: 2200,
    descripcion: 'MacBook Pro 14" con chip M3, 16GB RAM unificada, SSD 512GB. Ideal para desarrollo, diseño y edición de video. Incluye cargador MagSafe y funda de cuero.',
    fotos: ['https://images.unsplash.com/photo-1541807084-5c52b6b3adef?w=400', 'https://images.unsplash.com/photo-1517336714731-489689fd1ca8?w=400'],
    ownerId: 'user2',
    ownerName: 'Studio Creative',
    tags: ['macbook', 'apple', 'laptop', 'profesional'],
    estado: 'Como nuevo',
    ubicacion: 'Córdoba, Argentina',
    categoria: 'laptops',
    createdAt: new Date('2024-01-10')
  },
  {
    id: '3',
    uuid: '3',
    titulo: 'Samsung Galaxy S24 Ultra',
    precio: 950,
    descripcion: 'Galaxy S24 Ultra 512GB con S Pen incluido. Cámara de 200MP, pantalla Dynamic AMOLED 2X. Perfecto para fotografía profesional y productividad.',
    fotos: ['https://images.unsplash.com/photo-1610945265064-0e34e5519bbf?w=400', 'https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400'],
    ownerId: 'user3',
    ownerName: 'Ana Photography',
    tags: ['samsung', 'galaxy', 'smartphone', 'camara'],
    estado: 'Excelente',
    ubicacion: 'Rosario, Argentina',
    categoria: 'smartphones',
    createdAt: new Date('2024-01-08')
  },
  {
    id: '4',
    uuid: '4',
    titulo: 'PlayStation 5 Slim + 2 Controles',
    precio: 650,
    descripcion: 'PS5 Slim nueva generación con 2 controles DualSense, base vertical y 5 juegos digitales incluidos. Garantía extendida por 2 años.',
    fotos: ['https://images.unsplash.com/photo-1606813907291-d86efa9b94db?w=400', 'https://images.unsplash.com/photo-1493711662062-fa541adb3fc8?w=400'],
    ownerId: 'user4',
    ownerName: 'Gaming Central',
    tags: ['playstation', 'gaming', 'consola', 'videojuegos'],
    estado: 'Nuevo',
    ubicacion: 'Mendoza, Argentina',
    categoria: 'gaming',
    createdAt: new Date('2024-01-05')
  },
  {
    id: '5',
    uuid: '5',
    titulo: 'iPad Pro 12.9" M2 + Apple Pencil',
    precio: 1100,
    descripcion: 'iPad Pro 12.9" con chip M2, 256GB WiFi + Cellular. Incluye Apple Pencil 2da gen, Magic Keyboard y funda protectora. Ideal para diseño y trabajo.',
    fotos: ['https://images.unsplash.com/photo-1544244015-0df4b3ffc6b0?w=400', 'https://images.unsplash.com/photo-1561154464-82e9adf32764?w=400'],
    ownerId: 'user5',
    ownerName: 'Design Studio',
    tags: ['ipad', 'apple', 'tablet', 'diseño'],
    estado: 'Muy bueno',
    ubicacion: 'La Plata, Argentina',
    createdAt: new Date('2024-01-03')
  },
  {
    id: '6',
    uuid: '6',
    titulo: 'ASUS ROG Strix RTX 4080',
    precio: 1800,
    descripcion: 'Tarjeta gráfica ASUS ROG Strix GeForce RTX 4080 16GB. Perfecta para gaming 4K y renderizado profesional. Refrigeración triple ventilador.',
    fotos: ['https://images.unsplash.com/photo-1591488320449-011701bb6704?w=400', 'https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=400'],
    ownerId: 'user6',
    ownerName: 'PC Master Race',
    tags: ['gpu', 'gaming', 'nvidia', 'componentes'],
    estado: 'Excelente',
    ubicacion: 'Tucumán, Argentina',
    createdAt: new Date('2024-01-01')
  },
  {
    id: '7',
    uuid: '7',
    titulo: 'Nintendo Switch OLED + Juegos',
    precio: 420,
    descripcion: 'Nintendo Switch OLED modelo blanco con 8 juegos físicos incluidos: Zelda, Mario Kart, Smash Bros y más. Pro Controller incluido.',
    fotos: ['https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400'],
    ownerId: 'user7',
    ownerName: 'Nintendo Fan',
    tags: ['nintendo', 'switch', 'gaming', 'portatil'],
    estado: 'Muy bueno',
    ubicacion: 'Salta, Argentina',
    createdAt: new Date('2023-12-28')
  },
  {
    id: '8',
    uuid: '8',
    titulo: 'AirPods Pro 2da Gen + MagSafe',
    precio: 280,
    descripcion: 'AirPods Pro 2da generación con cancelación activa de ruido, audio espacial y estuche MagSafe. Incluye todos los tamaños de almohadillas.',
    fotos: ['https://images.unsplash.com/photo-1588423771073-b8903fbb85b5?w=400'],
    ownerId: 'user8',
    ownerName: 'Audio Expert',
    tags: ['airpods', 'apple', 'audio', 'inalambricos'],
    estado: 'Como nuevo',
    ubicacion: 'Mar del Plata, Argentina',
    createdAt: new Date('2023-12-25')
  },
  {
    id: '9',
    uuid: '9',
    titulo: 'Dell XPS 13 Plus i7 32GB',
    precio: 1600,
    descripcion: 'Ultrabook Dell XPS 13 Plus con Intel i7-12700H, 32GB RAM, SSD 1TB. Pantalla 4K OLED táctil. Perfecta para profesionales y creativos.',
    fotos: ['https://images.unsplash.com/photo-1496181133206-80ce9b88a853?w=400'],
    ownerId: 'user9',
    ownerName: 'Business Pro',
    tags: ['dell', 'laptop', 'ultrabook', 'profesional'],
    estado: 'Excelente',
    ubicacion: 'Neuquén, Argentina',
    createdAt: new Date('2023-12-20')
  },
  {
    id: '10',
    uuid: '10',
    titulo: 'iPhone 14 Pro 128GB Morado',
    precio: 850,
    descripcion: 'iPhone 14 Pro en color morado profundo, 128GB. Dynamic Island, cámara de 48MP, ProRAW. Batería al 95%, sin detalles estéticos.',
    fotos: ['https://images.unsplash.com/photo-1663499482523-1c0c1bae4ce1?w=400'],
    ownerId: 'user10',
    ownerName: 'Mobile Store',
    tags: ['iphone', 'apple', 'smartphone', 'camara'],
    estado: 'Muy bueno',
    ubicacion: 'Santa Fe, Argentina',
    createdAt: new Date('2023-12-18')
  },
  {
    id: '11',
    uuid: '11',
    titulo: 'Samsung Odyssey G9 49" Curvo',
    precio: 1200,
    descripcion: 'Monitor gaming Samsung Odyssey G9 49" curvo, 240Hz, 1ms, HDR1000. Resolución 5120x1440. Perfecto para gaming competitivo y productividad.',
    fotos: ['https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=400'],
    ownerId: 'user11',
    ownerName: 'Setup Master',
    tags: ['monitor', 'gaming', 'samsung', 'curvo'],
    estado: 'Excelente',
    ubicacion: 'Bahía Blanca, Argentina',
    createdAt: new Date('2023-12-15')
  },
  {
    id: '12',
    uuid: '12',
    titulo: 'Google Pixel 8 Pro 256GB',
    precio: 750,
    descripcion: 'Google Pixel 8 Pro con IA avanzada, cámara computacional líder, 256GB almacenamiento. Actualizaciones Android garantizadas por 7 años.',
    fotos: ['https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400'],
    ownerId: 'user12',
    ownerName: 'Tech Innovator',
    tags: ['pixel', 'google', 'smartphone', 'ia'],
    estado: 'Como nuevo',
    ubicacion: 'Corrientes, Argentina',
    createdAt: new Date('2023-12-12')
  },
  {
    id: '13',
    uuid: '13',
    titulo: 'Xbox Series X + Game Pass',
    precio: 580,
    descripcion: 'Xbox Series X con 1TB SSD, 2 controles inalámbricos y 3 años de Game Pass Ultimate incluidos. Más de 400 juegos disponibles.',
    fotos: ['https://images.unsplash.com/photo-1621259182978-fbf93132d53d?w=400'],
    ownerId: 'user13',
    ownerName: 'Xbox Gamer',
    tags: ['xbox', 'gaming', 'consola', 'gamepass'],
    estado: 'Muy bueno',
    ubicacion: 'Posadas, Argentina',
    createdAt: new Date('2023-12-10')
  },
  {
    id: '14',
    uuid: '14',
    titulo: 'Surface Pro 9 i7 + Type Cover',
    precio: 1300,
    descripcion: 'Microsoft Surface Pro 9 con Intel i7, 16GB RAM, SSD 512GB. Incluye Type Cover, Surface Pen y dock USB-C. 2-en-1 perfecta para trabajo.',
    fotos: ['https://images.unsplash.com/photo-1588872657578-7efd1f1555ed?w=400'],
    ownerId: 'user14',
    ownerName: 'Microsoft Partner',
    tags: ['surface', 'microsoft', 'tablet', '2en1'],
    estado: 'Excelente',
    ubicacion: 'San Juan, Argentina',
    createdAt: new Date('2023-12-08')
  },
  {
    id: '15',
    uuid: '15',
    titulo: 'Sony WH-1000XM5 + Estuche',
    precio: 320,
    descripcion: 'Auriculares Sony WH-1000XM5 con cancelación de ruido líder en la industria. 30h de batería, carga rápida, estuche de viaje premium incluido.',
    fotos: ['https://images.unsplash.com/photo-1583394838336-acd977736f90?w=400'],
    ownerId: 'user15',
    ownerName: 'Audio Specialist',
    tags: ['sony', 'auriculares', 'audio', 'premium'],
    estado: 'Como nuevo',
    ubicacion: 'Río Gallegos, Argentina',
    createdAt: new Date('2023-12-05')
  },
  {
    id: '16',
    uuid: '16',
    titulo: 'Steam Deck 512GB + Accesorios',
    precio: 680,
    descripcion: 'Steam Deck 512GB con pantalla anti-reflejo, estuche exclusivo, dock oficial y 64GB microSD. Tu biblioteca de Steam en cualquier lugar.',
    fotos: ['https://images.unsplash.com/photo-1578662996442-48f60103fc96?w=400'],
    ownerId: 'user16',
    ownerName: 'Portable Gamer',
    tags: ['steamdeck', 'gaming', 'portatil', 'valve'],
    estado: 'Muy bueno',
    ubicacion: 'Ushuaia, Argentina',
    createdAt: new Date('2023-12-03')
  },
  {
    id: '17',
    uuid: '17',
    titulo: 'Canon EOS R6 Mark II + Lente',
    precio: 2800,
    descripcion: 'Cámara Canon EOS R6 Mark II con lente RF 24-70mm f/2.8L. Perfecta para fotografía profesional y video 4K. Incluye batería extra y tarjeta CF.',
    fotos: ['https://images.unsplash.com/photo-1502920917128-1aa500764cbd?w=400'],
    ownerId: 'user17',
    ownerName: 'Pro Photographer',
    tags: ['canon', 'camara', 'fotografia', 'profesional'],
    estado: 'Excelente',
    ubicacion: 'San Luis, Argentina',
    createdAt: new Date('2023-12-01')
  },
  {
    id: '18',
    uuid: '18',
    titulo: 'Xiaomi 13 Ultra 512GB',
    precio: 890,
    descripcion: 'Xiaomi 13 Ultra con cámara Leica, 512GB almacenamiento, carga rápida 90W. El flagship más potente de Xiaomi con diseño premium.',
    fotos: ['https://images.unsplash.com/photo-1511707171634-5f897ff02aa9?w=400'],
    ownerId: 'user18',
    ownerName: 'Xiaomi Official',
    tags: ['xiaomi', 'smartphone', 'leica', 'flagship'],
    estado: 'Como nuevo',
    ubicacion: 'Formosa, Argentina',
    createdAt: new Date('2023-11-28')
  },
  {
    id: '19',
    uuid: '19',
    titulo: 'Razer DeathAdder V3 Pro',
    precio: 150,
    descripcion: 'Mouse gaming inalámbrico Razer con sensor Focus Pro 30K, switches ópticos y batería de 90 horas.',
    fotos: ['https://images.unsplash.com/photo-1527864550417-7fd91fc51a46?w=400'],
    ownerId: 'user19',
    ownerName: 'Gaming Gear',
    tags: ['gaming', 'mouse', 'razer', 'inalambrico'],
    estado: 'Nuevo',
    ubicacion: 'CABA, Argentina',
    categoria: 'gaming',
    createdAt: new Date('2023-11-25')
  },
  {
    id: '20',
    uuid: '20',
    titulo: 'Apple Watch Series 9 45mm',
    precio: 420,
    descripcion: 'Apple Watch Series 9 GPS + Cellular, caja de aluminio, correa deportiva. Incluye cargador y caja original.',
    fotos: ['https://images.unsplash.com/photo-1434493789847-2f02dc6ca35d?w=400'],
    ownerId: 'user20',
    ownerName: 'Apple Store',
    tags: ['apple', 'watch', 'smartwatch', 'fitness'],
    estado: 'Excelente',
    ubicacion: 'Rosario, Argentina',
    categoria: 'wearables',
    createdAt: new Date('2023-11-22')
  }
];